export const createCrop = (crop) => {
    if (crop && typeof crop.x === 'number') {
        return `${crop.x},${crop.y},${crop.width},${crop.height}`;
    }
    return '';
};
